export enum FuelChangeTypeFilter {
  All = 0,
  Increases = 1,
  Decreases = 2
}